/**
 * Common event metadata stamped onto every RUM custom event. Holds the small
 * set of per-event-useful, session-varying context (normalized route,
 * featureArea, backendRegion) and merges it under any event-specific payload.
 * Everything passes through the allowlist sanitizer, so a forbidden key can
 * never enter via this path. Session-scoped attributes (applicationVersion,
 * env, region, role, …) are set separately as RUM session attributes by
 * rumClient and are attached to events by RUM server-side.
 */
import { sanitizeEventPayload } from './telemetrySanitizer';
import type { SafePayload } from './rumEvents';

let commonEventContext: SafePayload = {};

/** Merge sanitized partial context into the common event context. */
export function setCommonEventContext(partial: Record<string, unknown>): void {
  const safe = sanitizeEventPayload(partial);
  commonEventContext = { ...commonEventContext, ...safe };
}

export function getCommonEventContext(): SafePayload {
  return { ...commonEventContext };
}

/** Build the final, fully-sanitized metadata for one event. */
export function buildEventMetadata(payload?: Record<string, unknown> | null): SafePayload {
  return { ...commonEventContext, ...sanitizeEventPayload(payload ?? {}) };
}

/** Test-only reset of module state. */
export function resetCommonEventContext(): void {
  commonEventContext = {};
}
